import { useQuery } from "@tanstack/react-query";
import { AutoComplete, AutoCompleteProps } from "antd";
import axios from "axios";
import type { BaseSelectRef } from "rc-select";
import { useRef, useState } from "react";

export interface SelectConsumable {
  id: number | null;
  name: string;
  units: string[];
}

export interface ConsumableSelectProps extends AutoCompleteProps {
  value?: SelectConsumable;
  onChange?: (value?: SelectConsumable) => void;
}

export default function ConsumableSelect({
  value,
  onChange: parentOnChange,
  ...props
}: ConsumableSelectProps) {
  const [search, setSearch] = useState("");
  const input = useRef<BaseSelectRef>(null);

  const { data } = useQuery({
    queryFn: () =>
      axios
        .get<SelectConsumable[]>("/consumable_search", {
          params: { name: search || "" },
        })
        .then((x) => x.data),
    staleTime: 0,
    queryKey: ["consumables_search", search],
  });

  const onChange = (consumableName: string) => {
    if (consumableName === "") {
      setSearch("");
      parentOnChange?.(undefined);
    } else {
      setSearch(consumableName);
      parentOnChange?.({ id: null, name: consumableName, units: [] });
    }
  };

  const onSelect = (consumable: SelectConsumable) => {
    parentOnChange?.(consumable);
    input.current?.blur();
  };

  return (
    <AutoComplete
      {...props}
      options={data?.map((x) => ({
        key: x.id,
        label: x.name,
        value: x.name,
        consumable: x,
      }))}
      ref={input}
      placeholder="Select or create"
      value={value?.name}
      onSearch={onChange}
      onChange={onChange}
      onSelect={(_, option) => onSelect(option.consumable)}
      allowClear
    />
  );
}
